export default [
  {
    id: 'listrule1l',
    append: '**prior to 29.07.24**',
    title: 'Listing Rules'
  }
]
